import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ArticleStore } from './+state/article.store';
import { ExternalResourceStore } from './+state/external-resource.store';
import { SpotifyLinkStore } from './+state/spotify-link.store';
import { KnowledgeService } from './service/knowledge.service';
import { ArticleDetailsStore } from './+state/article-details.store';

export function provideKnowledge(): EnvironmentProviders {
  return makeEnvironmentProviders([
    KnowledgeService,
    ArticleStore,
    ArticleDetailsStore,
    SpotifyLinkStore,
    ExternalResourceStore,
  ]);
}
